var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTextFormat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86001 6L1.14401 18.6H3.28601L4.45601 15.486H9.62201L10.81 18.6H13.024L8.32601 6H5.86001ZM9.04601 13.722H5.03201L7.03001 8.232L9.04601 13.722Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.317 18.6V16.814H21.918C21.4873 16.814 21.272 16.586 21.272 16.13V12.292C21.272 11.152 20.9173 10.278 20.208 9.67C19.4987 9.062 18.4917 8.758 17.187 8.758C15.9583 8.758 14.964 9.03033 14.204 9.575C13.444 10.107 13.0133 10.8607 12.912 11.836H14.926C15.002 11.4053 15.23 11.0633 15.61 10.81C16.0027 10.544 16.4967 10.411 17.092 10.411C17.7633 10.411 18.289 10.5693 18.669 10.886C19.049 11.19 19.239 11.6143 19.239 12.159V12.748H16.788C15.4327 12.748 14.4003 13.0203 13.691 13.565C12.9817 14.097 12.627 14.8633 12.627 15.864C12.627 16.7507 12.9563 17.4473 13.615 17.954C14.2737 18.4607 15.1477 18.714 16.237 18.714C17.643 18.714 18.7133 18.1567 19.448 17.042C19.448 17.5487 19.5873 17.935 19.866 18.201C20.1447 18.467 20.6007 18.6 21.234 18.6H22.317ZM16.693 14.268H19.239V14.61C19.2263 15.37 18.9793 15.978 18.498 16.434C18.0293 16.89 17.3707 17.118 16.522 17.118C15.9647 17.118 15.5213 16.9913 15.192 16.738C14.8753 16.4847 14.717 16.149 14.717 15.731C14.717 15.2497 14.888 14.8887 15.23 14.648C15.572 14.3947 16.0597 14.268 16.693 14.268Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextFormat);
export default __webpack_public_path__ + "static/media/icon-text-format.a779c00567bb935c4232e01eff22d77c.svg";
export { ForwardRef as ReactComponent };